import { useState, createContext, useContext } from 'react'

// Создаём контекст для передачи активного таба
const TabsContext = createContext(null)

export const Tabs = ({ value, onValueChange, defaultValue, children }) => {
  // Поддержка как контролируемого (value + onValueChange), так и неконтролируемого режима (defaultValue)
  const [internalValue, setInternalValue] = useState(defaultValue ?? '')

  const activeValue = value ?? internalValue

  const handleValueChange = (newValue) => {
    if (onValueChange) {
      onValueChange(newValue)
    } else {
      setInternalValue(newValue)
    }
  }

  return (
    <TabsContext.Provider value={{ activeValue, handleValueChange }}>
      <div>{children}</div>
    </TabsContext.Provider>
  )
}

export const TabsList = ({ children, className }) => {
  return (
    <div className={`flex border-b ${className ?? ''}`}>
      {children}
    </div>
  )
}

export const TabsTrigger = ({ value, children, className, ...props }) => {
  const { activeValue, handleValueChange } = useContext(TabsContext)

  const isActive = activeValue === value

  return (
    <button
      {...props}
      onClick={() => handleValueChange(value)}
      className={
        `px-4 py-2 font-medium transition-colors
        ${isActive
          ? 'text-blue-600 border-b-2 border-blue-600'
          : 'text-gray-700 border-b-2 border-transparent hover:border-blue-400'
        }
        ${className ?? ''}`
      }
    >
      {children}
    </button>
  )
}

export const TabsContent = ({ value, children, className }) => {
  const { activeValue } = useContext(TabsContext)

  // Рендерим только активный таб
  if (activeValue !== value) return null

  return (
    <div className={`pt-4 ${className ?? ''}`}>
      {children}
    </div>
  )
}
